// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_am-3";
export var contentContainer = "_am-0";
export var editorContainer = "_am-1";
export var quillInputForm = "_am-2";
export var zoneDivider = "_am-4";